// Setting
export const DRAWER_COLLAPSED = "drawerCollapsed";
